import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DocsHeader from './DocsHeader';
import DocsSidebar from './DocsSidebar';
import SupportChat from '../common/SupportChat';

const DocsLayout = ({ children }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [showSupportChat, setShowSupportChat] = useState(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  // Get current location from params
  const currentCategory = params.category || null;
  const currentArticle = params.article || null;

  const handleNavigate = (categorySlug, articleSlug) => {
    if (articleSlug) {
      navigate(`/docs/${categorySlug}/${articleSlug}`);
    } else if (categorySlug) {
      navigate(`/docs/${categorySlug}`);
    } else {
      navigate('/docs');
    }
    // Close mobile drawer after navigating
    setMobileDrawerOpen(false);
  };

  return (
    <div className="docs-layout" style={{
      minHeight: '100vh',
      backgroundColor: '#ffffff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <DocsHeader
        onStartChat={() => setShowSupportChat(true)}
        onToggleDrawer={() => setMobileDrawerOpen(prev => !prev)}
        mobileDrawerOpen={mobileDrawerOpen}
      />

      <DocsSidebar
        currentCategory={currentCategory}
        currentArticle={currentArticle}
        onNavigate={handleNavigate}
        mobileDrawerOpen={mobileDrawerOpen}
        onCloseDrawer={() => setMobileDrawerOpen(false)}
      />

      {/* Drawer backdrop - mobile only, only when open */}
      {mobileDrawerOpen && (
        <div
          className="docs-drawer-backdrop"
          onClick={() => setMobileDrawerOpen(false)}
          style={{
            position: 'fixed',
            top: '56px',
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            zIndex: 998,
            display: 'none'
          }}
        />
      )}

      <main className="docs-main" style={{
        marginLeft: '300px',
        marginTop: '64px',
        minHeight: 'calc(100vh - 64px)',
        backgroundColor: '#ffffff'
      }}>
        {React.cloneElement(children, { onNavigate: handleNavigate })}
      </main>

      <SupportChat
        isOpen={showSupportChat}
        onClose={() => setShowSupportChat(false)}
      />

      {/* Mobile responsive overrides */}
      <style>{`
        @media (max-width: 768px) {
          .docs-main {
            margin-left: 0 !important;
            margin-top: 56px !important;
            min-height: calc(100vh - 56px) !important;
          }
          .docs-drawer-backdrop {
            display: block !important;
          }
        }
      `}</style>
    </div>
  );
};

export default DocsLayout;